export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE_SIZE_INFINITY = 10 ** 6;

export const PAGINATION = {
  DEFAULT_PAGE,
  DEFAULT_LIMIT: 50,
  MAX_LIMIT: 100,
};
